import { type ReactNode } from 'react'

/** One row of the Actions tab's settings-style list: label + description on the left, the
 *  control(s) that act on it on the right - the conventional settings-page layout, rather than
 *  a cluster of icon buttons. `last` drops the row divider (the final row in a section). */
export function ActionRow({ title, description, last, children }: {
  title: ReactNode
  description: ReactNode
  last?: boolean
  children: ReactNode
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, padding: '16px 0', borderBottom: last ? 'none' : '1px solid var(--border)' }}>
      <div style={{ flex: 1, minWidth: 0, paddingRight: 12 }}>
        <div style={{ fontFamily: 'var(--body)', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{title}</div>
        <div style={{ fontFamily: 'var(--body)', fontSize: '0.78rem', color: 'var(--text2)', lineHeight: 1.5 }}>{description}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>{children}</div>
    </div>
  )
}
